import React from "react"
import _ from "lodash"

type IHover = {
  data: {}
}

const NotesHover = (props: IHover) => {
  const notes = props.data['notedetail']?.['notes'].slice(0, 30) || ''

  return (
    <div style={{padding: "15px"}}>
      <p>{ notes } { notes.length === 30 && '...' }</p>
    </div>
  )
}

export default NotesHover
